<template>

	<b class="screen-overlay"></b>

	<!-- Page content -->
	<div class="page-content" style="height: 100%;">

		<!-- Main sidebar -->
		<div class="sidebar sidebar-dark sidebar-main sidebar-expand-lg" v-bind:class="{'sidebar-expand-lg':utente.ID_UTENTE > 0}" v-show="utente.ID_UTENTE > 0">

			<!-- Sidebar header -->
			<div class="sidebar-section bg-black bg-opacity-10 border-bottom border-bottom-white border-opacity-10">
				<div class="sidebar-logo d-flex justify-content-center align-items-center">
					<router-link  class="d-inline-flex align-items-center py-2" href="#" :to="'Dashboard'">
						<img src="./assets/images/logo_icon_light.png" class="sidebar-logo-icon" alt="">
                        <img src="./assets/images/logo_light_theb.png" class="sidebar-resize-hide ms-3" height="22" alt="">
					</router-link>

					<div class="sidebar-resize-hide ms-auto">
						<button id="btnCollapseMain" type="button" class="btn btn-flat-white btn-icon btn-sm rounded-pill border-transparent sidebar-control sidebar-main-resize d-none d-lg-inline-flex">
							<i class="ph-arrows-left-right"></i>
						</button>

						<button type="button" class="btn btn-flat-white btn-icon btn-sm rounded-pill border-transparent sidebar-mobile-main-toggle d-lg-none">
							<i class="ph-x"></i>
						</button>
					</div>
				</div>
			</div>
			<!-- /sidebar header -->

			<!-- Sidebar content -->
			<div class="sidebar-content" v-show="utente.ID_UTENTE > 0">

				<div class="sidebar-section">
					<div class="sidebar-section-body d-flex justify-content-center">
					</div>
				</div>

				<!-- Main navigation -->
				<div class="sidebar-section">
					<ul class="nav nav-sidebar" data-nav-type="accordion">
						<MenuRoot v-if="utente.ID_UTENTE > 0 && arrayMenus.length > 0" :items="menuCorrente(2)" :type="'nav-laterale'" @route-click="openRoute"></MenuRoot>
					</ul>
				</div>
				<!-- /main navigation -->

			</div>
			<!-- /sidebar content -->

		</div>
		<!-- /main sidebar -->	

		<!-- Main content -->
		<div class="content-wrapper">	

			<!-- Navigation -->
			<div class="navbar navbar-dark navbar-expand-lg navbar-static shadow" v-show="utente.ID_UTENTE > 0">
				<div class="container-fluid">
					
					<div class="d-flex d-lg-none me-2">
						<button type="button" class="navbar-toggler sidebar-mobile-main-toggle bg-light bg-opacity-20 text-reset rounded-pill me-2">
							<i class="ph-arrows-left-right"></i>
						</button>
						<div class="d-xl-none">
							<button type="button" class="navbar-toggler collapsed" data-bs-toggle="collapse" data-bs-target="#navbar-navigation" aria-expanded="false">
								<i class="ph-list"></i>
							</button>
						</div>
						<router-link class="d-inline-flex align-items-center" href="#" :to="'Dashboard'" style="margin-left: 4rem !important; margin-right: 50%;">
							<img src="./assets/images/logo_icon_light.png" class="sidebar-logo-icon" alt="">
						</router-link>
						<div class="d-xl-none float-end">
							<button type="button" class="navbar-toggler collapsed" data-bs-toggle="collapse" data-bs-target="#navbar-mixed" aria-expanded="false">
								<i class="ph-squares-four"></i>
							</button>
						</div>
					</div>

					<div class="navbar-collapse collapse" id="navbar-navigation" style="">
						<ul class="navbar-nav mt-2 mt-xl-0">

							<MenuRoot v-if="utente.ID_UTENTE > 0 && arrayMenus.length > 0" :items="menuCorrente(1)" :type="'nav-superiore'" @route-click="openRoute"></MenuRoot>

						</ul>
					</div>	

					<div class="navbar-collapse collapse" id="navbar-mixed">
						<ul class="nav flex-row ms-auto mt-xs-1">
							
							<li class="nav-item dropdown">
								<a href="#" class="navbar-nav-link rounded dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
									<img :src="filters.getImgPath('ENTI',idEnteCorrente+'.png')" class="rounded-circle me-2" height="24" alt="" v-on:click="apriSitoWeb(idEnteCorrente,'SITE_URL')" /> 
									<span class="hidden-xs" v-if="enteCorrente != undefined">{{enteCorrente.LABEL}}</span>
								</a>
								<div class="dropdown-menu">
									<div v-for="ente in $root.arrayEnti" v-bind:key="ente.ID_ENTE">
										<a href="#" v-on:click="switchEnte(ente)" class="dropdown-item">
											<img :src="filters.getImgPath('ENTI',ente.ID_ENTE+'.png')" width="24" height="24" class="rounded-circle me-2" alt="" v-on:click="apriSitoWeb(ente.ID_ENTE,'SITE_URL')" />
											<span class="fw-bold">{{ ente.LABEL }}</span>
										</a>
									</div>
								</div>
							</li>

							<li class="nav-item dropdown mt-1 me-xs-1">
								<a href="#" class="navbar-nav-link rounded dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
									<Flag :country="currentLang" class="me-1"></Flag>
								</a>
								<div class="dropdown-menu dropdown-menu-start">
									<div v-for="lang in arrayLingue" v-bind:key="lang.ID_GEO_STATO">
										<a href="#" v-on:click="currentLang = lang.ID_GEO_STATO" class="dropdown-item h-25px" >
											<Flag :country="lang.ID_GEO_STATO" class="me-1"></Flag> {{ lang.NOME }}
										</a>
									</div>
								</div>
							</li>
							
							<li class="nav-item nav-item-dropdown-lg dropdown dropdown-leftms-lg-2">
								<a href="#" class="navbar-nav-link navbar-nav-link-icon rounded-pill" data-bs-toggle="dropdown" data-bs-auto-close="outside">
									<i class="ph-chats"></i>
									<span class="badge bg-yellow text-black position-absolute top-0 end-0 translate-middle-top zindex-1 rounded-pill mt-1 me-1">{{ contatoreMessaggi }} </span>
								</a>
								<div class="dropdown-menu dropdown-menu-end wmin-lg-400 p-0">
									<div class="d-flex align-items-center p-3">
										<h6 class="mb-0">Ultime Chat</h6>
									</div>
									<div class="box-prodotto">
										<div class="dropdown-menu-scrollable pb-0" v-for="msg in arrayMessaggiNonLetti.messaggi_non_letti" v-bind:value="msg.ID_MESSAGE" v-bind:key="msg.ID_MESSAGE">
											<a href="#" class="dropdown-item align-items-start text-wrap py-2">
												<div class="status-indicator-container me-3">
													<img v-if="msg.ID_PERSONA_FISICA > 0 && msg.URL_AVATAR != 'placeholder.jpg'" :src="filters.getImgPath('USERS',msg.URL_AVATAR)" class="w-40px h-40px rounded-pill" alt="" />
													<img v-if="msg.URL_AVATAR == 'placeholder.jpg'" src="./assets/images/face11.jpg" class="w-40px h-40px rounded-pill" alt="">
													<span class="status-indicator " v-bind:class="{'bg-danger':msg.STATO_ACCESSO == 0,'bg-success':msg.STATO_ACCESSO == 1,'bg-warning':msg.STATO_ACCESSO == 2}"></span>
												</div>
												<div class="flex-1">
													<span class="fw-semibold">{{ msg.USERNAME }}</span>
													<span class="text-muted float-end fs-sm">{{ msg.DATA_INVIO }}</span>
													<div class="text-muted">{{ msg.TEXT }}</div>
												</div>
											</a>
										</div>
									</div>
									<div class="d-flex border-top py-2 px-3">
										<a class="text-body cursor-pointer" v-on:click="markAllAsRead()">
											Segna come letti
											<i class="far fa-check-double me-1"></i>
										</a>
										<a href="#" class="text-body ms-auto cursor-pointer" v-on:click="openRoute('/Chat')">
											Val alla Chat
											<i class="ph-arrow-circle-right ms-1"></i>
										</a>
									</div>
								</div>
							</li>

							<li class="nav-item me-lg-3 me-xs-2">
								<a href="#" class="navbar-nav-link navbar-nav-link-icon rounded-pill" v-on:click="notifiche()">
									<i class="ph-bell"></i>
									<span class="badge bg-yellow text-black position-absolute top-0 end-0 translate-middle-top zindex-1 rounded-pill mt-1 me-1">
										{{ contatoreNotifiche }}
									</span>
								</a>
							</li>

							<li class="nav-item nav-item-dropdown-lg dropdown ms-3">
								<a href="#" class="navbar-nav-link align-items-center rounded-pill p-1" data-bs-toggle="dropdown">
									<div class="status-indicator-container">
										<img v-if="utente.ID_UTENTE > 0 && utente.URL_AVATAR != 'placeholder.jpg'" :src="filters.getImgPath('USERS',utente.URL_AVATAR)" class="w-32px h-32px rounded-pill" alt="" />
										<div v-if="utente.URL_AVATAR == 'placeholder.jpg' || utente.ID_UTENTE == 0" class="btn-nophoto w-32px h-32px rounded-pill">No<br />Photo</div>
										<span class="status-indicator " v-bind:class="getUserStatusClass(utente.ID_UTENTE,arrayUtentiAdmin)"></span>
									</div>
									<span class="d-none d-lg-inline-block mx-lg-2">{{ utente.USERNAME }}</span>
								</a>
			
								<div class="dropdown-menu dropdown-menu-end">
									<div class="dropdown-submenu dropdown-submenu-start">
										<a href="#" class="dropdown-item"><i class="ph-baby me-2"></i><span class="text-muted me-1">|</span>Il mio stato</a>
										<div class="dropdown-menu">
											<a href="#" class="dropdown-item" v-on:click="setUserStatus(1)"><i class="far fa-thumbs-up text-success fa-fw me-2"></i>Disponibile</a>
											<a href="#" class="dropdown-item" v-on:click="setUserStatus(2)"><i class="far fa-thumbs-down text-warning fa-fw me-2"></i>Non disturbare</a>
										</div>
									</div>
									<a href="#" class="dropdown-item" v-on:click="openRoute('/Task')">
										<i class="ph-envelope-open me-2"></i>To Do
										<!--<span class="badge bg-primary rounded-pill ms-auto">{{ totalTask }} </span> -->
									</a>
									<a href="#" class="dropdown-item" v-if="livello == 5">
										<i class="ph-currency-circle-dollar me-2"></i>Sottoscrizioni
									</a>
									<a href="#" class="dropdown-item" v-if="livello == 5">
										<i class="ph-shopping-cart me-2"></i>Ordini
									</a>
									<div class="dropdown-divider"></div>
									<a href="#" v-on:click="openOffCanvas();openSchedaVisualizzazioneUtente(utente)" class="dropdown-item">
										<i class="ph-user-circle me-2"></i>Mostra Profilo
									</a>
									<div class="dropdown-divider"></div>
									<a href="#" v-on:click="logout()" class="dropdown-item">
										<i class="ph-sign-out me-2 text-danger"></i>Logout
									</a>
								</div>
							</li>

						</ul>

					</div>
					
				</div>
			</div>
			<!-- /navigation -->
			
			<!-- Inner content -->
			<div class="content-inner">

				<!--<router-view/> -->
				<router-view v-slot="{ Component }">
					<component ref="view" :is="Component" />
				</router-view>

				<!--
				<div v-if="is_Dashboard">
					
					<--a Footer 
					<div class="navbar navbar-sm border-top mt-3" v-show="utente.ID_UTENTE > 0">
						<div class="container-fluid">
							<span>&copy; 2024 <a href="https://www.webfortravel.it" target="_blank">Web For Travel</a></span>

							<ul class="nav flex-row">
								<li class="nav-item ms-md-1">
									<a href="#" class="navbar-nav-link navbar-nav-link-icon rounded" v-on:click="openRoute('/Manuals')">
										<div class="d-flex align-items-center">
											<i class="icon-book me-1"></i>
											<span class="d-none d-md-inline-block ms-1"><Translate :path="'dizionario.base.DOCS_MANUAL'"></Translate></span>
										</div>
									</a>
								</li>
								<li class="nav-item ms-md-1">
									<a href="#" class="navbar-nav-link navbar-nav-link-icon rounded" v-on:click="openRoute('/Tickets')">
										<div class="d-flex align-items-center">
											<i class="icon-lifebuoy me-1"></i>
											<span class="d-none d-md-inline-block ms-1">Ticket</span>
										</div>
									</a>
								</li>
								<li class="nav-item nav-item-dropdown-lg dropup ms-md-1">
									<a  href="#" class="navbar-nav-link navbar-nav-link-icon text-pink bg-pink bg-opacity-10 fw-semibold rounded" :class="{ 'disabled': disableMail }"  :disabled="disableMail"  v-on:click="openRoute('/Inbox')">
										<i class="ph-envelope-simple-open me-1"></i>
										<span class="d-none d-md-inline-block ms-1"><Translate :path="'dizionario.base.INBOX'"></Translate></span>
									</a>
								</li>
								<li class="nav-item nav-item-dropdown-lg dropup ms-md-1">
									<a href="#" class="navbar-nav-link navbar-nav-link-icon text-success bg-success bg-opacity-10 fw-semibold rounded" v-on:click="openRoute('/Chat')">
										<i class="ph-chat-circle-text me-1"></i>
										<span class="d-none d-md-inline-block ms-1">Chat</span>
									</a>
								</li>
							</ul>
						</div>
					</div>
					<--a /footer 

				</div>
				-->

			</div>
			<!-- /inner content -->

			<!-- <div v-if="!is_Dashboard"> -->

				<!-- Footer -->
				<div class="navbar navbar-sm border-top" v-show="utente.ID_UTENTE > 0">
					<div class="container-fluid">
						<span>&copy; 2024 <a href="https://www.webfortravel.it" target="_blank">Web For Travel</a></span>

						<ul class="nav flex-row">
							<li class="nav-item ms-md-1">
								<a href="#" class="navbar-nav-link navbar-nav-link-icon rounded" v-on:click="openRoute('/Manuals')">
									<div class="d-flex align-items-center">
										<i class="icon-book me-1"></i>
										<span class="d-none d-md-inline-block ms-1"><Translate :path="'dizionario.base.DOCS_MANUAL'"></Translate></span>
									</div>
								</a>
							</li>
							<li class="nav-item ms-md-1">
								<a href="#" class="navbar-nav-link navbar-nav-link-icon rounded" v-on:click="openRoute('/Tickets')">
									<div class="d-flex align-items-center">
										<i class="icon-lifebuoy me-1"></i>
										<span class="d-none d-md-inline-block ms-1">Ticket</span>
									</div>
								</a>
							</li>
							<li class="nav-item nav-item-dropdown-lg dropup ms-md-1">
								<a  href="#" class="navbar-nav-link navbar-nav-link-icon text-pink bg-pink bg-opacity-10 fw-semibold rounded" :class="{ 'disabled': disableMail }"  :disabled="disableMail"  v-on:click="openRoute('/Inbox')">
									<i class="ph-envelope-simple-open me-1"></i>
									<span class="d-none d-md-inline-block ms-1"><Translate :path="'dizionario.base.INBOX'"></Translate></span>
								</a>
							</li>
							<li class="nav-item nav-item-dropdown-lg dropup ms-md-1">
								<a href="#" class="navbar-nav-link navbar-nav-link-icon text-success bg-success bg-opacity-10 fw-semibold rounded" v-on:click="openRoute('/Chat')">
									<i class="ph-chat-circle-text me-1"></i>
									<span class="d-none d-md-inline-block ms-1">Chat</span>
								</a>
							</li>
						</ul>
					</div>
				</div>
				<!-- /footer -->

			<!-- </div> -->

		</div>
        <!-- /main content -->

		<SchedaUtente :ref="'schedaUtente'" @updateGriglia="getUtenti()"></SchedaUtente>

	</div>
	<!-- /page content -->	


	<!-- START MODALI -->
	<div class="offcanvas offcanvas-end offcanvas-size-xlg" id="panel_right_help" data-bs-backdrop="false" role="dialog" tabindex="-1">
		<div class="offcanvas-header bg-pink text-white border-0" style="height: 3.95rem;">
			<h5 class="modal-title modal-title-width">
				<i class="ph-list icon-modal-size me-2"></i>Scheda help 
			</h5> 
			<button type="button" class="btn btn-light btn-sm btn-icon border-transparent rounded-pill" data-bs-dismiss="offcanvas">
				<i class="ph-x icon-x-size"></i>
			</button>
		</div>
		<div class="offcanvas-body p-2">

			<SchedaVisualizzazioneHelp :ref="'schedaVisualizzazioneHelp'"></SchedaVisualizzazioneHelp>

		</div>
        <div class="border-top p-1 bg-light">                                
			<button type="button" class="btn btn-link float-end" data-bs-dismiss="offcanvas">
				<i class="fal fa-sign-out-alt fa-fw me-2"></i><Translate :path="'dizionario.base.BTN_CLOSE'"></Translate>
			</button> 
        </div>
	</div>  
		    
    <div class="offcanvas offcanvas-end offcanvas-size-xlg" id="panel_right_user" data-bs-backdrop="false" role="dialog" tabindex="-1">
		<div class="offcanvas-header bg-info text-white border-0" style="height: 3.95rem;">
			<h5 class="modal-title modal-title-width">
				<i class="ph-list icon-modal-size me-2"></i>Scheda informativa 
			</h5>  
			<div class="btn-group float-end" :tabindex="2" v-show="livello == 5">
				<a href="#" class="badge bg-yellow text-dark p-2 dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">Comunicazioni</a>
				<div class="dropdown-menu dropdown-position dropdown-menu-end" data-popper-placement="bottom-start" style="position: absolute; inset: 0px auto auto 0px; margin: 0px; transform: translate3d(0px, 42px, 0px);">
					<a href="#" class="dropdown-item"><i class="fal fa-print me-2"></i> Stampa scheda </a>
					<a href="#" class="dropdown-item"><i class="fal fa-envelope me-2"></i> Invia comunicazione </a>
					<a href="#" class="dropdown-item"><i class="fal fa-paper-plane me-2"></i> Invia sms </a>
				</div>
			</div> 	
			<button type="button" class="btn btn-light btn-sm btn-icon border-transparent rounded-pill" data-bs-dismiss="offcanvas">
				<i class="ph-x icon-x-size"></i>
			</button>
		</div>
		<div class="offcanvas-body p-2">

			<SchedaVisualizzazioneUtente :ref="'schedaVisualizzazioneUtente'" @modificaUtente="modificaUtente($event)"></SchedaVisualizzazioneUtente>

		</div>
        <div class="border-top p-1 bg-light">                                
			<button type="button" class="btn btn-link float-end" data-bs-dismiss="offcanvas">
				<i class="fal fa-sign-out-alt fa-fw me-2"></i><Translate :path="'dizionario.base.BTN_CLOSE'"></Translate>
			</button> 
        </div>
	</div>

	<div class="offcanvas offcanvas-end offcanvas-size-lg" id="panel_notifiche" data-bs-backdrop="false" role="dialog" tabindex="-1">
		<div class="offcanvas-header bg-info text-white border-0" style="height: 3.95rem;">
			<h5 class="modal-title modal-title-width">
				<i class="ph-list icon-modal-size me-2"></i>Scheda notifiche 
			</h5> 
			<button type="button" class="btn btn-light btn-sm btn-icon border-transparent rounded-pill" data-bs-dismiss="offcanvas" v-on:click="chiudiOffCanvas()">
				<i class="ph-x icon-x-size"></i>
			</button>
		</div>
		<div class="offcanvas-body p-0">
			
			<Notifiche :ref="'schedaNotifiche'" :mostra="mostraNotifiche" @chiudi="mostraNotifiche = false" :arrayNotifiche="arrayNotifiche" @getNotifiche="getNotifiche"></Notifiche>
			
		</div>
        <div class="border-top p-1 bg-light">                                
			<button type="button" class="btn btn-link float-end" data-bs-dismiss="offcanvas">
				<i class="fal fa-sign-out-alt fa-fw me-2"></i><Translate :path="'dizionario.base.BTN_CLOSE'"></Translate>
			</button> 
        </div>
	</div>

	<div class="modal" id="popUpConfirm"  >
		<div class="modal-dialog"  >
			<div class="modal-content" >
				<div class="modal-header modal-header-info">
					<h5 class="modal-title">{{alertConfirm.TITLE}}</h5>
					<button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
					</button>
				</div>
				<div class="modal-body">
				<div class="row">
					<div class="col-md-2" style="margin-top:10px;font-size:40px">
						<i class="fas " v-bind:class="alertConfirm.ICON"></i>
					</div>
					<div class="col-md-10 align-items-center" style="margin-top:10px">
						<div v-html="alertConfirm.MESSAGE"></div>
					</div>
				</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-danger" v-on:click="alertConfirm.KOHandler()"><i class="fa fa-times fa-fw"></i>{{alertConfirm.KO}}</button>
					<button type="button" class="btn btn-success" v-on:click="alertConfirm.OKHandler()"><i class="fa fa-check fa-fw"></i>{{alertConfirm.OK}}</button>
				</div>
			</div>
		</div>
	</div>

	<div class="modal fade show" id="popUpSessionExpired">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title">Session Timeout</h5>
				</div>
				<div class="modal-body">
					<p>Your session is about to expire. Do you want to stay connected?</p>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-danger" v-on:click="handleSessionLogout()"><i class="ph-sign-out me-2"></i>Esci</button>
					<button type="button" class="btn btn-primary" v-on:click="handleSessionContinue()"><i class="ph-arrow-clockwise me-2"></i>Continua</button>
				</div>
			</div>
		</div>
	</div>


</template>


<script>
import Img from '@/components/utils/Img.vue'
import Flag from '@/components/utils/Flag.vue'
import MenuRoot from '@/components/utils/MenuRoot.vue'
import googlePlaces from '@/composables/googlePlaces';
import SchedaUtente from '@/components/SchedaUtente.vue'
import SchedaVisualizzazioneHelp from '@/components/SchedaVisualizzazioneHelp.vue'
import SchedaVisualizzazioneUtente from '@/components/SchedaVisualizzazioneUtente.vue' 
import Notifiche from '@/components/Notifiche.vue' 
//import { windowOpen } from 'echarts/types/src/util/format.js';



export default {
    name: 'App', 

	components:{
		Img,
		Flag,
		MenuRoot,
		SchedaUtente,
		SchedaVisualizzazioneHelp,
		SchedaVisualizzazioneUtente,
		Notifiche,
    },

	props:["livello"],

    data:function(){
        return {
			alertConfirm:{
				MESSAGE:"prova"
			},
			filters:global.filters,
			zindex:1100,
			title:'Dashboard',
			icon:'fa-home',
			ordineSelezionato:{},
			preventivoSelezionato:{},
			sidebarHasBeenResized:false,
			passwordUtente:{},
			isAdmin : false,
			isGod : false,
			utente:{funzionalita: new Array()},
			arrayMenu: new Array(),
			arrayMenus: new Array(),
			menuSelezionato: new Array(),
			idStagioneCorrente:0,
			isMobile:false,
			previousRoute:"/",
			currentLang:118,
			GLOBAL_IMAGES_PATH:'',
			GLOBAL_THEME_IMAGES_PATH:'',
			savedSearch:{},
			idSetting:0,
			prodotto:{},
			stagione:{},
			progetto:{},
			percorsoLang:'',
			sottoProdotto:{},
			geoLangSelezionato:{},
			idEnteCorrente:0,
			mostraNotifiche : false,
			FK_ID_MODULO_TIPOLOGICHE:0,
			arrayModuli : new Array(
					{ID:1,DESCRIZIONE:"ATTIVITA'"},
					{ID:2,DESCRIZIONE:"HOTEL"},
					{ID:3,DESCRIZIONE:"PACCHETTI"},
					{ID:4,DESCRIZIONE:"VOLI"},
					{ID:5,DESCRIZIONE:"CAMERE"},
					),
			dizionario:{},
			//////////////////////////// TIPOLOGICHE 					
			arrayTipologieOpzioni : new Array(),
			arrayUtentiAdmin : new Array(),
			arrayEnti : new Array(),
			arrayCodiciIva : new Array(),
			arrayTipoFiscale : new Array(),
			arrayTipoModuli : new Array(),
			arrayTipoCategoria : new Array(),
			arrayTipoContenuto : new Array(),
			arrayModalitaCalcolo : new Array(),
			arrayPromotori : new Array(),
			arrayAgenti : new Array(),
			arrayConti : new Array(),
			arrayGeoStati : new Array(),
			arrayGeoComuni : new Array(),
			arrayAeroporti : new Array(),
			arrayLivelli : new Array(),
			arrayGruppi : new Array(),
			arrayFunzionalita : new Array(),
			arrayMenuItems : new Array(),
			arrayTipoAgenzia : new Array(),
			arrayTipoFornitore : new Array(),
			arrayLingue : new Array(),
			arrayRuoliUtente : new Array(),
			arrayStagioni : new Array(),
			arrayRtsType : new Array(),
			arrayPraticaStato : new Array(),
			arrayPraticaBook : new Array(),
			arrayPraticaTipo : new Array(),
			arrayPraticaPagamento : new Array(),
			arrayPraticaDocumento : new Array(),
			arrayAllOpzioni : new Array(),
			arrayNetwork : new Array(),
			arrayTipologieNotifiche: new Array(),
			arrayOpzioniSitoAll : new Array(),
			statistiche: {},
			currentModulo:0,
			COSTANTI:{},
			VERSIONE:'',
			CHAT_PATH:'',
			arrayChatUtente : new Array(),
			connessioneSocket: 0,
            appoggio: {
                socket: null
            },
			contatoreNotifiche : 0,
			contatoreMessaggi : 0,
			arrayNotifiche : new Array(),
			arrayMessaggiNonLetti : new Array(),
			allowedDates : new Array(),
			disableMail : true,
			newEmailCount: 0,
			socketConnected : false,
			cartellaSelezionata: '',
			totalTask: 0,
			confUtente: {},
			openToDo: false,
			token:'',
			// Gestione timer sessione
			sessionTimer: null,  // Interval timer
			SESSION_WARNING_MINUTES: 5,  // Mostra avviso 5 minuti prima della scadenza
			arrayProgetti:new Array(),
			firmeVersion: 0

        } 
    },

    methods : {
		startUp : function(){
			global.utils.ajax('core/home',{}, (response) => {
				this.$root.arrayTipologieOpzioni = response.data.OPZIONI;
				this.$root.arrayEnti = response.data.ENTI;
				this.$root.idEnteCorrente = response.data.ENTE.ID_ENTE;
				this.$root.arrayUtentiAdmin = response.data.UTENTI_ADMIN;
				this.$root.arrayCodiciIva = response.data.CODICI_IVA;
				this.$root.arrayTipoModuli = response.data.TIPO_MODULI;
				this.$root.arrayTipoFiscale = response.data.TIPO_FISCALE;
				this.$root.arrayTipoCategoria = response.data.TIPO_CATEGORIA;
				this.$root.arrayTipoContenuto = response.data.TIPO_CONTENUTO;
				this.$root.arrayModalitaCalcolo = response.data.MODALITA_DI_CALCOLO;
				this.$root.arrayPromotori = response.data.PROMOTORI;
				this.$root.arrayNetwork = response.data.NETWORK;
				this.$root.arrayAgenti = response.data.AGENTI;
				this.$root.arrayConti = response.data.CONTI;
				this.$root.arrayGeoStati = response.data.GEO_STATI;
				this.$root.arrayLivelli = response.data.LIVELLI;
				this.$root.arrayFunzionalita = response.data.FUNZIONALITA;
				this.$root.arrayMenuItems = response.data.MENU_ITEMS;
				this.$root.arrayGruppi = response.data.GRUPPI;
				this.$root.arrayRuoliUtente = response.data.RUOLI_UTENTE;
				this.$root.arrayRtsType = response.data.RTS_TYPE;
				for (var i = 0 ; i < this.$root.arrayGruppi.length ; i++) {
					this.$root.arrayGruppi[i].FLG_PROFILO = 0;
					if (this.$root.arrayGruppi[i].DESCRIZIONE.search("PROFILO: ") > -1){
						this.$root.arrayGruppi[i].DESCRIZIONE = this.$root.arrayGruppi[i].DESCRIZIONE.replace("PROFILO: ","");
						this.$root.arrayGruppi[i].FLG_PROFILO = 1;
					}
				}
				this.$root.arrayTipoAgenzia = response.data.TIPO_AGENZIA;
				this.$root.arrayTipoFornitore = response.data.TIPO_FORNITORE;
				this.$root.arrayLingue = response.data.LINGUE;
				this.$root.arrayStagioni = response.data.STAGIONI;
				this.$root.arrayPraticaStato = response.data.TIPO_PRATICA_STATO;
				this.$root.arrayPraticaBook = response.data.TIPO_PRATICA_BOOK;
				this.$root.arrayPraticaTipo = response.data.TIPO_PRATICA;
				this.$root.arrayPraticaPagamento = response.data.TIPO_PRATICA_PAGAMENTO;
				this.$root.arrayPraticaDocumento = response.data.TIPO_PRATICA_DOCUMENTI;
				this.$root.statistiche = response.data.STATISTICHE;
				this.$root.arrayAllOpzioni = response.data.ALL_OPZIONI;
				this.$root.arrayGeoComuni = response.data.GEO_COMUNI;
				this.$root.arrayAeroporti = response.data.AEROPORTI;
				this.$root.COSTANTI = response.data.COSTANTI;
				global.filters.init(this.$root);
				var opzioneSidebar = global.filters.getOpzioneUtente("SIDEBAR");
				if (opzioneSidebar == 244){
					document.getElementById("btnCollapseMain").click();
				}
				this.$forceUpdate();
			});
		},
		logout : function(){
			this.stopSessionMonitor();
			if(this.appoggio && this.appoggio.socket){
				this.appoggio.socket.emit('updateUserStatus', { userId : this.utente.ID_UTENTE})
				this.appoggio.socket.disconnect();
				this.socketConnected = false;
				this.appoggio.socket = null;
			}
			global.utils.ajax('core/logout',{}, (response) => {
				//$('.sidebar').removeClass("sidebar-main-resized");
				this.$root.utente = {};
				global.utils.deleteCookie("session_token");
				global.utils.deleteCookie("api_token");
				global.utils.SESSION_TOKEN = "";
				global.utils.API_TOKEN = "";
				global.router.push("Login");
				this.arrayMenu = new Array();
			});
   		},

      	isCurrent : function(menu){
			if ("/"+menu == this.currentRouteName){
				return true;
			}
      	},
		
		confirm : function(alertConfirm){
			this.alertConfirm = alertConfirm;
			this.filters.openPopUp("popUpConfirm");
		},

		setHeader : function(_title,_icon){
			this.title = _title;
			this.icon = _icon;
		},

		back : function(){
			global.router.go(-1);
		},

		modificaPassword : function(){
			this.filters.openPopUp("popUpModificaPassword");
		},

		switchEnte : function(ente){
			global.utils.ajax('travel/switchtEnte',{FK_ID_ENTE:ente.ID_ENTE, ID_ENTI_ABILITATI : this.utente.enti}, (response,status) => {
				if (response.esito == 0){
					global.utils.alert.success("Operazione correttamente eseguita");
					this.idEnteCorrente = ente.ID_ENTE;
					//$('#listaEnti').removeClass("show");
					//$('#divListaEnti').removeClass("show");
					utils.removeClass("listaEnti","show");
					utils.removeClass("divListaEnti","show");
					//console.log(this.$refs.view);
					if (typeof this.$refs.view.refreshEnte == 'function'){
						this.$refs.view.refreshEnte();
					}
					//this.$root.$emit('ente-cambiato', ente.ID_ENTE);					
				}
				else {
					//(messaggio,titolo = "Attenzione", delay = 2500, icona = "",)
					global.utils.alert.danger("Non sei autorizzato ad accedere a questa sezione.",'ATTENZIONE');
				} 
			},true,1);
		}, 

		openSchedaUtente: function(){
			this.$refs.schedaUtente.openSchedaUtente(this.utente);
		},

		modificaUtente: function(utente) {
			this.$refs.schedaUtente.openSchedaUtente(utente);
		},

		modificaProfilo : function(){
			global.router.push("Profilo");
		},

		openRoute : function(route){
			//console.log('sto aprendo');
			global.router.push(route);
		},

		doModificaPassword : function(){
			//)7.HRK=L3M!xiyRq,vZ
			this.filters.closePopUp("popUpModificaPassword");
			global.utils.ajax('core/utente/password/update',this.passwordUtente, (response,status) => {
				if (response.esito == 0){
					global.utils.alert.success("Operazione correttamente eseguita");
				}
			});
		},

		getDataColor : function(route){
			return route.DESCRIZIONE;
		},

		openPopUpLogin : function(){
			this.filters.openPopUp("popUpRecoveryLogin");
		},

		checkMobile : function(route){
			if (this.isMobile == false){
				return true;
			}
			else{
				if (route.ROUTE == '/Soci' || route.ROUTE == '/aaattivita' || route.ROUTE == '/abbonamenti'){
					return true;
				}
			}
			return false;
		},

		getLang : function(){
			return this.currentlang;
		},

		refreshUtentiAdmin : function(){
			global.utils.ajax('travel/utentiAdmin',{}, (response,status) => {
				if (response.esito == 0){
					this.arrayUtentiAdmin = response.data;
				}
			});
		},

		confTravelTipologiche : function(idModulo){
			this.FK_ID_MODULO_TIPOLOGICHE = idModulo;
            global.router.push("ConfGenerali");
		},

		
        getTipologieNotificheUtente : function(utente){
            utils.ajax("shared/notifiche/tipologie/utenti",{ID_UTENTE:utente.ID_UTENTE}, (response) => {
                if(response.esito == 0){
                    this.arrayTipologieNotifiche = response.data;
                }               
            });
        },

		getLangModulo : function(idModulo){
			var modulo = utils.array.select(this.arrayTipoModuli,"ICONA",idModulo,1)[0];
			return modulo;
		},

		confTravelLingue : function(idModulo){
			this.currentModulo = idModulo;
			this.percorsoLang = this.getLangModulo(idModulo).CUSTOM_2;
			global.router.push("Lingua");
		},

		preventivo : function(){
			this.ordineSelezionato = {ID_ORDINE:0,INTESTATARIO_FK_ID_PERSONA_FISICA:0,INTESTATARIO_FK_ID_PERSONA_GIURIDICA:0};
			this.openRoute('/Quota');
		},

		getMenu : function(idType){
			utils.ajax("core/menu/singolo",{ID_TYPE:idType}, (response) => {
                this.menuSelezionato = response.data;
				return response.data
            });
		},

		getMenuAlls : function(){
			utils.ajax("core/menu/childrens",{}, (response) => {
                this.arrayMenus = response.data;
            });
		},

		////////////////////////////////////////////////////////////////// GESTIONE DELLE LINGUE ///////////////////////////////////////////////////////////
		translate : function(percorso){
			if (this.dizionario != null){
				var percorsi = percorso.split(".");
				var parziale = this.dizionario;
				for (var i = 0 ; i < percorsi.length ; i++){
					parziale = parziale[percorsi[i]];
					if (parziale == undefined){
						return "";
					}
				}
				return parziale[this.currentLang];
			}
			else{
				return "";
			}
			/*
			else{
				utils.wait(()=>{
					this.translate(lingua,percorso);
				});
			}*/
		},

		getDizionarioPercorso : function(percorso){
			var percorsi = percorso.split(".");
			var parziale = this.dizionario.dizionario;
			for (var i = 0 ; i < percorsi.length ; i++){
				parziale = parziale[percorsi[i]];
				if (parziale == undefined){
					return null;
				}
			}
			var arrayDefinizioni = new Array();
			Object.keys(parziale).forEach(key => {
				for (var i = 0 ; i < filters.root.arrayLingue.length ; i++){
					var FK_ID_LINGUA = filters.root.arrayLingue[i].ID_GEO_STATO;
					var val = parziale[key][FK_ID_LINGUA];
					arrayDefinizioni.push({DEFINIZIONE:key,VALORE:val,FK_ID_LINGUA:FK_ID_LINGUA,FK_ID_DEFINIZIONE:key,ID_DEFINIZIONE:i.toString()+"_"+FK_ID_LINGUA});
				}
			});
			return arrayDefinizioni;
		},

		getDizionario : function(handler = null){
			global.utils.ajax('core/dizionario',{}, (response,status) => {
				this.dizionario = response.data; 
				if (handler != null)          {
					handler(this.dizionario);
				}
			});
		},

		svuotaCache : function(){
			global.utils.ajax('core/cache', (response,status) => {
				if (response.esito == 0){
					global.utils.alert.success("Operazione correttamente eseguita");
				}
			});
		},


		help : function(_modulo){
			var myOffcanvas = document.getElementById('panel_right_help')
			var bsOffcanvas = new bootstrap.Offcanvas(myOffcanvas)
			bsOffcanvas.show();
			this.$refs.schedaVisualizzazioneHelp.openSchedaVisualizzazioneHelp(_modulo);
		},

		setUserStatus(newStatus) {
			this.isDropdownOpen = false;
			const userId = this.utente.ID_UTENTE;
			global.utils.ajax('chad_2/admin/updateUserStatus', { userId: userId, newStatus: newStatus }, (response) => {
				if (response.esito == 0) {
					this.utente.STATO_ACCESSO = newStatus;
					this.appoggio.socket.emit('updateUserStatus', { userId: userId, newStatus: newStatus }); // invia evento al server
				} else {
					console.error('Errore nel cambiare lo stato dell\'utente', response);
				}
			});
		},

		getUtentiAdmin(_fake){
			global.utils.ajax('core/admin/utenti/light', {fake: _fake}, (response, status) => {
				if (response.esito == 0) {
					this.arrayUtentiAdmin = response.data;
				} else {
					console.error('Errore nel recupero degli utenti:', response);
				}
			});
		},

		cronJob : function(){
			global.utils.ajax('core/admin/aggiornautenti', {fake:true}, (response,status) => {
				if (response.esito == 0){
					global.utils.ajax('core/admin/utenti/light', {fake:true}, (response,status) => {
						if (response.esito == 0){
							global.utils.alert.success("Utenti recuperati");
							this.arrayUtentiAdmin = response.data;
						}
						else {
							global.utils.alert.warning("Non ho recuperato gli utenti ");
						}
					});
				}
				else {
					global.utils.alert.warning("Nessun Utente Aggiornato ");
				}
			});
		},

        getUserStatusClass(userId,_arrayUtenti) {
			if(this.utente && this.utente.ID_UTENTE == userId){
				if (this.utente.STATO_ACCESSO == 1) return 'bg-success';  
                if (this.utente.STATO_ACCESSO == 2) return 'bg-warning';
				return 'bg-danger'  
			}

            const utente = _arrayUtenti.find(utente => utente.ID_UTENTE == userId);
            if (utente) {
                if (utente.STATO_ACCESSO == 1) return 'bg-success';  
                if (utente.STATO_ACCESSO == 2) return 'bg-warning';  
                 
            }
            return 'bg-danger';
        },

		openOffCanvas : function(){
			var myOffcanvas = document.getElementById('panel_right_user')
			var bsOffcanvas = new bootstrap.Offcanvas(myOffcanvas)
			bsOffcanvas.show();
		},

		openSchedaVisualizzazioneUtente : function(utente,tab = ""){
			this.utenteSelezionato = utils.clone(utente);	
			this.$refs.schedaVisualizzazioneUtente.openSchedaVisualizzazioneUtente(utente,tab);
		},

		connectSocket() {
			if(!this.appoggio.socket){
				utils.connect(this.CHAT_PATH, this, 'https', this.handleSocketConnect);
			}
		},

		handleSocketConnect() {
			if (!this.appoggio.socket || !this.appoggio.socket.connected) {
				console.warn("Socket non pronto, attendo connessione...");
				return;
			}
			console.info("CONNESSIONE SOCKET AVVENUTA");
			if (this.utente && this.utente.ID_UTENTE) {
				console.log("Invio evento joinApp per l'utente:", this.utente.ID_UTENTE);
				// UserId ora proviene dal JWT, non inviarlo come parametro
				this.appoggio.socket.emit("joinApp", { SESSION_TOKEN: utils.SESSION_TOKEN });
			}

			
			this.socketConnected = true;
			if(this.appoggio.socket){
				//console.log('passo qui');
				this.appoggio.socket.on("new-email", (data) => {
					this.newEmailCount += data.numNewMsgs;
					utils.alert.success(`📩 Hai ${this.newEmailCount} nuove email!`);
				});
				
				this.appoggio.socket.on("new-promemoria", (data) => {
					console.log("promemoria ricevuto :", data);
					const msg = `🕑 Ti ricordo di completare la task: "${data.titolo}"`;
					utils.alert.info(msg,'','',10000);
					this.getNotifiche();
				});

				this.appoggio.socket.on("taskScadenza", (data) => {
					const { scadute, inScadenza } = data;
					const msg = `🕑 Hai "${scadute}" task scadute e "${inScadenza} in scadenza"`;
					utils.alert.warning(msg);
					console.log("Promemoria ricevuto:", data);
				});
			}

        },

		startHandler : function(){
			this.arrayMenu = new Array();
			global.router.push("Start");
			//1.VERIFICO ESISTENZA TOKEN
			//console.log("*** AVVIO APPLICAZIONE ***");
			var token = global.utils.getCookie("session_token");
			var session_started_at = global.utils.getCookie("session_started_at");
			var session_timeout = global.utils.getCookie("session_timeout");
			
			//SE E' PRESENTE IL TOKEN, PROVIAMO A RECUPERARE L'Utente
			if (token != "" && token != undefined && token != "undefined"){
				global.utils.SESSION_TOKEN = token;
				if (session_timeout && session_timeout != "undefined") {
					global.utils.TIMEOUT_SESSIONE = parseInt(session_timeout);
				}
				if (session_started_at && session_started_at != "undefined") {
					global.utils.INIZIO_SESSIONE = parseInt(session_started_at);
				}
				global.utils.ajax('core/logged',{}, (response) => {
					if (response.esito == 0 && response.data.UTENTE.ID_UTENTE > 0){
						this.utente = response.data.UTENTE;
						if (response.data.API_TOKEN) {
							global.utils.API_TOKEN = response.data.API_TOKEN;
							global.utils.setCookie("api_token", response.data.API_TOKEN);
						}
						this.arrayMenu = response.data.UTENTE.menuItems;
						let userId = this.utente.ID_UTENTE;

						if (global.utils.TIMEOUT_SESSIONE && global.utils.INIZIO_SESSIONE) {
							this.startSessionMonitor();
						}
						//console.log(userId);
						if(this.socketConnected == false){
							this.connectSocket();
							this.socketConnected = true
						}
						/*if (userId) {
							try {
								this.appoggio.socket.emit('joinApp', userId);
							} catch (error) {
								console.error("Errore durante l'invio dell'evento 'joinApp' sul socket:", error);
								this.showError("Impossibile connettersi all'applicazione. Riprova più tardi.");
							}
						}*/
						for (var i = 0 ; i < this.utente.funzionalita.length ; i++){
							if (this.utente.funzionalita[i].FK_ID_ITEM > 0){
								this.arrayMenu.push(this.utente.funzionalita[i].menuItem);
							}
						}
						
						if(this.appoggio && this.appoggio.socket){
							this.appoggio.socket.emit('updateUserStatus', { userId: this.utente.ID_UTENTE, newStatus: 1 });
						}
						global.router.push("Dashboard");
						//this.getUtentiAdmin(false);			
						this.checkIfGod();
						this.getNotifiche();
						this.appoggio.socket.on('userStatusUpdated', (data) => {
							const { userId, newStatus } = data;
							if(this.utente.ID_UTENTE == userId){
								this.utente.STATO_ACCESSO = newStatus
							}

							const utente = this.arrayUtentiAdmin.find(utente => utente.ID_UTENTE == userId);
							if (utente) {
								utente.STATO_ACCESSO = newStatus; // Aggiorna lo stato dell'utente
							}
							console.log("Lo stato dell'utente" + userId + "è stato aggiornato a"+ newStatus)
						});
						
						this.getMenuAlls();
						this.aggiornaMessaggiDaApp();
						this.getTipologieNotificheUtente(this.utente);
						this.getOpzioniSitoAll();

						
					}
					else {
						global.router.push("Login");
						this.arrayMenu = new Array();
					}
					//this.getToken();
				});
				
			}
			else{
				//this.$forceUpdate();
				this.arrayMenu = new Array();
				utils.wait(()=>{
					global.router.push("Login");
				})

			}
			
			
			
		},

		getNotifiche() {
            console.log('Recupero delle notifiche dal server...');
            utils.ajax('shared/notifiche', {FK_ID_UTENTE : this.$root.utente.ID_UTENTE}, (response) => {
                if (response && response.esito == 0) {
					this.arrayNotifiche = response.data;
					this.contatoreNotifiche = this.arrayNotifiche.length;
                }
            },false);
        },

		notifiche : function(){
			var myOffcanvas = document.getElementById('panel_notifiche')
			var bsOffcanvas = new bootstrap.Offcanvas(myOffcanvas)
			bsOffcanvas.show();
			this.getNotifiche();
			this.mostraNotifiche = true;
		},

		getMessaggiNonLetti() {
			console.log('Recupero dei messaggi...');
			utils.ajax('chad_2/messaggi_non_letti/utente', { FK_ID_UTENTE: this.$root.utente.ID_UTENTE }, (response) => {
				if (response && response.esito == 0) {
					this.arrayMessaggiNonLetti = response.data;
					this.contatoreMessaggi = this.arrayMessaggiNonLetti.messaggi_non_letti.length
				}
			},false);
		},

		playSound(soundPath) {
			const audio = new Audio(soundPath);
			audio.play().catch((error) => {
				console.warn('Errore nella riproduzione del suono:', error);
			});
		},

		aggiornaMessaggiDaApp() {
			this.getMessaggiNonLetti();
			if (this.appoggio.socket) {
				this.appoggio.socket.on('receiveMessage', (message) => {
					if (message.FK_ID_USER != this.utente.ID_UTENTE) {
						this.playSound(require('@/assets/sounds/bloop.mp3'));
						this.getMessaggiNonLetti();
					}
				});
				this.appoggio.socket.on('messagesRead', (data) => {
					console.log("CLIENT: Arrivato markAsRead con data =", data);
					if (this.arrayMessaggiNonLetti && this.arrayMessaggiNonLetti.messaggi_non_letti && Array.isArray(this.arrayMessaggiNonLetti.messaggi_non_letti)) {
						this.arrayMessaggiNonLetti.messaggi_non_letti =
						this.arrayMessaggiNonLetti.messaggi_non_letti.filter(msg => msg.FK_ID_CHAT != data.chatId);
						this.contatoreMessaggi = this.arrayMessaggiNonLetti.messaggi_non_letti.length;
					}
					setTimeout(() => {
						this.getMessaggiNonLetti();
					}, 500);
				});
			}
		},

		chiudiOffCanvas() {
			this.mostraNotifiche = false;
		},
		
        checkIfGod() {
           this.isGod = this.$root.utente.FK_ID_LIVELLO == 1;
        },

        hasFunzionalita(azione) {
            return this.isGod || utils.permissions.hasFunzionalita(azione);
        },

		hasMenuItemPermission(itemId) {
			if (this.isGod) return true;
			const protectedSet = this.protectedMenuItemIds;
			if (!protectedSet.has(itemId)) return true; // item non protetto = visibile a tutti
			return this.allowedMenuItemIds?.has(itemId) ?? false;
		},

		markAllAsRead() {
			utils.ajax('chad_2/messaggi/markMultipleAsRead', {ID_UTENTE : this.$root.utente.ID_UTENTE}, (response) => {        
				if (response && response.esito == 0) {
				this.getMessaggiNonLetti();
				utils.alert.success('Tutti i messaggi sono stati aggiornati come letti.');
				} else {
				utils.alert.danger('Errore nell\'aggiornamento dello stato dei messaggi.');
				}
			},false);
		},
			
		goToLogs : function(folder,modulo){
			this.cartellaSelezionata = folder;
			global.router.push(modulo);
			
		},

		getOpzioniSitoAll(){
            utils.ajax('core/opzioni/sito', {}, (response) => {
				this.arrayOpzioniSitoAll = response.data;
            });
		},

		apriSitoWeb(id,label){
			var url = this.filters.getOpzioniSitoByLabel(id,label,this.arrayOpzioniSitoAll);
			window.open(url, "_blank");
		},

		//get token
		/*
		getToken(callback) {
			utils.ajax('core/get_token', {USERNAME : process.env.VUE_APP_USERNAME, PASSWORD: process.env.VUE_APP_PASSWORD }, (response) => {
				this.token = response.data.TOKENS.GESTIONALE.TOKEN;
				global.utils.API_TOKEN = this.token;
				if (typeof callback === "function") {
					callback(); // chiama startHandler
				}
			});
		},
		*/

		handleSessionContinue: function() {
			const modalEl = document.getElementById('popUpSessionExpired');
			const modal = bootstrap.Modal.getInstance(modalEl);
			if (modal) modal.hide();

			this.startHandler();
			this.resetSessionTimer();
			global.utils.alert.success("Sessione rinnovata!");
			console.log('Sessione rinnovata - timer resettato');
		},

		handleSessionLogout: function() {
			const modalEl = document.getElementById('popUpSessionExpired');
			const modal = bootstrap.Modal.getInstance(modalEl);
			if (modal) modal.hide();
			this.logout();
		},

		startSessionMonitor: function() {
			//eventuale timer precedente
			if (this.sessionTimer) {
				clearInterval(this.sessionTimer);
			}

			// Controlla ogni 30 secondi
			this.sessionTimer = setInterval(() => {
				const now = Math.floor(Date.now() / 1000);
				const passati = now - global.utils.INIZIO_SESSIONE;
				const rimanenti = global.utils.TIMEOUT_SESSIONE - passati;

				const warningThreshold = this.SESSION_WARNING_MINUTES * 60;  // 5 minuti in secondi

				// Se mancano meno di 5 minuti e non abbiamo mostrato l'avviso
				if (rimanenti <= warningThreshold && rimanenti > 0) {
					const modalEl = document.getElementById('popUpSessionExpired');
					const modalInstance = bootstrap.Modal.getInstance(modalEl);

			
					if (!modalInstance || !modalEl.classList.contains('show')) {
						this.filters.openPopUp('popUpSessionExpired');
					}
				}

				// Se la sessione è scaduta
				if (rimanenti <= 0) {
					this.filters.closePopUp('popUpSessionExpired');
					clearInterval(this.sessionTimer);
					console.log('Sessione scaduta - logout automatico');
					this.logout();
				}
			}, 10000); // Controllo ogni 60 secondi

			console.log('Session monitor avviato');
		},

		resetSessionTimer: function() {
			// Reset del timer ad ogni interazione (chiamata AJAX riuscita)
			global.utils.INIZIO_SESSIONE = Math.floor(Date.now() / 1000);
		},

		stopSessionMonitor: function() {
			if (this.sessionTimer) {
				clearInterval(this.sessionTimer);
				this.sessionTimer = null;
				console.log('Session monitor fermato');
			}
		},

		checkModulo(nome){
			return this.$root.arrayProgetti.includes(nome);
		}
		

    },

    computed : {
		currentRouteName() {
			return this.$route.path;
		},

		mainMenuActive(){
			for (var i = 0 ; i < this.arrayMenu.length ; i++){
				if (this.arrayMenu[i].ROUTE == this.currentRouteName){
					return 1;
				}
			}
			return 0;
		},

		enteCorrente(){
			var ente = utils.array.select(this.arrayEnti,"ID_ENTE",this.idEnteCorrente,1)[0];
			return ente;
		},

		menuCorrente(){
			return(idType) => {
				return utils.array.select(this.arrayMenus,"FK_ID_TYPE",idType);
			}
		},

		is_Dashboard() {
			// Controlla se il nome della rotta corrente è 'Dash'
			// Assicurati che il nome 'Dash' corrisponda a quello che hai definito in Vue Router.
			return this.$route.name === 'Dashboard';
		},

		allowedMenuItemIds() {
			if (this.isGod) return null; // null = tutte visibili
			if (!this.utente?.funzionalita) return new Set();
			return new Set(
				this.utente.funzionalita
					.filter(f => f.FK_ID_ITEM > 0)
					.map(f => f.FK_ID_ITEM)
			);
		},

		protectedMenuItemIds() {
			if (!this.arrayFunzionalita) return new Set();
			return new Set(
				this.arrayFunzionalita
					.filter(f => f.FK_ID_ITEM > 0)
					.map(f => f.FK_ID_ITEM)
			);
		}

    },

    created : function(){
		var apiKey = process.env.VUE_APP_GOOGLE_MAPS_API_KEY;
		this.GLOBAL_THEME_IMAGES_PATH = process.env.VUE_APP_THEME_IMAGES_PATH;
		this.VERSIONE =  process.env.VUE_APP_VERSION_NUMBER;
		this.CHAT_PATH =  process.env.VUE_APP_CHAT_PATH;
		global.filters.init(this);
	

		const link = "https://maps.googleapis.com/maps/api/js?key="+apiKey+"&libraries=places&callback=Function.prototype"; //&callback=indirizzoSelezionato
		googlePlaces(link);
        var ua = navigator.userAgent;
        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua))
            this.isMobile = true;
        else
            this.isMobile = false;

		
		
        //global.utils.BASE_API = "http://localhost/dryland_2/CORE/SERVER/API/"; //process.env.VUE_APP_API_URL;
        global.utils.BASE_API = process.env.VUE_APP_API_URL; 
        this.GLOBAL_IMAGES_PATH = process.env.VUE_APP_GLOBAL_IMAGES_PATH;
		this.getDizionario();
		var savedApiToken = global.utils.getCookie("api_token");
		if (savedApiToken && savedApiToken != "" && savedApiToken != "undefined") {
			global.utils.API_TOKEN = savedApiToken;

		}
		this.startHandler();
		this.allowedDates = this.filters.generaArrayDate()
		setTimeout(() => {
			
			/*
            $('.modal').on('show.bs.modal',  (e) => {
                setTimeout(() => {
                    this.zindex++;
                    $('.modal-backdrop').last().css("z-index",this.zindex);
                    this.zindex++;
                    $('.modal.fade.show').last().css("z-index",this.zindex); 
                }, 200);
            }); */                   
        }, 400);

		//const userId = this.utente ? this.utente.ID_UTENTE : null;
		//this.appoggio.socket.emit('joinApp', userId);

    },
    
    watch:{
		currentlang(valore,valoreOld){
			if (valore != valoreOld){
			/*
			setTimeout(() => {
				global.t.currentlang = valore;
			},500)*/
			}
		},

        $route (valore,valoreOld){			
			//console.log(valore.path,valoreOld.path);
			this.previousRoute = valoreOld.path;
			if (valore.path == "/Pagamento"){
				this.previousRoute = "/pagamenti";
			}
			var list = document.getElementsByClassName("tooltip")
			for (var i = 0 ; i < list.length ; i++) {
				list[i].remove();
			}

			var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
			var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
			return new bootstrap.Popover(popoverTriggerEl)
			})

			var arr = document.getElementsByClassName("offcanvas")
			for (var i = 0 ; i < arr.length ; i++){
				arr[i].classList.remove("show")
			}
			global.utils.wait(()=>{
				global.utils.resizeContent();
			});
			
        }
    },

	mounted() {
		setTimeout(()=>{
			this.disableMail = false;
		},5000)
		
		/*document.addEventListener('click', () => {
			const audio = new Audio('assets/sounds/placeholder.mp3'); // Un suono silenzioso o vuoto
			audio.play().catch(() => {
				console.log('Riproduzione audio abilitata.');
			});
			document.removeEventListener('click', this); // Rimuovi il listener dopo il primo clic
		});
		
		/*const savedNotificationsEnabled = localStorage.getItem('notificationsEnabled');
		if (savedNotificationsEnabled !== null) {
			this.notificationsEnabled = JSON.parse(savedNotificationsEnabled);
		}
		this.appoggio.socket.on('connect', () => {
			const registraUtenteAlSocket = () => {
				const userId = this.utente ? this.utente.ID_UTENTE : null;

				if (userId) {
					console.log(`Registrazione utente ${userId} al socket`);
					// UserId ora proviene dal JWT, non inviarlo come parametro
					this.appoggio.socket.emit('joinApp');
				} else {
					console.warn('User ID non disponibile. Attendo che diventi disponibile...');
				}
			};
			registraUtenteAlSocket();
			this.$watch('utente', (newVal) => {
				if (newVal && newVal.ID_UTENTE) {
					registraUtenteAlSocket();
				}
			});
		});*/
	
	}


}
</script>
